import { Col, Row, Table, Tooltip } from 'antd';
import { DeleteOutlined, UploadOutlined,LinkOutlined } from '@ant-design/icons';
import React, { useEffect, useState } from 'react'
import { Button, Modal, Upload } from 'antd';
import { useMutation } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import HeadingBack from '../../../component/HeadingBack';
import { usePermission } from '../../../hooks/usePermission';
import { FaqServices } from '../../../redux/Services';
import AbhaLinkedFilter from '../AbhaFilter';
const ReportRequested = () => {
    const permission = usePermission("Faqs", "List");
    const navigate = useNavigate();
    const dispatch = useDispatch();
    // const faqList = useSelector(state => state.faq.faqList || []);
    // const totalFaq = useSelector(state => state.faq.totalFaq || "");
    const [page, setPage] = useState(1);
    const [filter, setFilter] = useState({});
    // const faqCategoryList = useSelector(state => state.faq.faqCategoryList || []);
    const { mutate: fetchFaqCategory } = useMutation((data) => dispatch(FaqServices.fetchFaqCategoryApi(data)));
    const { mutate: getfaqList, isLoading } = useMutation((data) => dispatch(FaqServices.fetchFaqApi(data)));

    const queryParams = new URLSearchParams(window.location.search);
    const [modal1Open, setModal1Open] = useState(false);
    useEffect(() => {
        getfaqList(filter);
        return () => { }
    }, [filter])

    useEffect(() => {
        fetchFaqCategory({ isActive: "1" });
        return () => { }
    }, [])
    const props = {
        action: '',
        onChange({ file, fileList }) {
            if (file.status !== 'uploading') {
                console.log(file, fileList);
            }
        },

        showUploadList: {
            showDownloadIcon: true,
            downloadIcon: 'Download',
            showRemoveIcon: true,
            removeIcon: <DeleteOutlined />,
        },
    };

    const json = {
        "firstName": "Amit",
        "lastName": "Smith",
        "isAlive": true,
        "age": 27,
        "address": {
            "streetAddress": "21 2nd Street",
            "city": "New York",
            "state": "NY",
            "postalCode": "10021-3100"
        },
        "phoneNumbers": [
            {
                "type": "home",
                "number": "212 555-1234"
            },
            {
                "type": "office",
                "number": "646 555-4567"
            }
        ],
        "children": [
            "Catherine",
            "Thomas",
            "Trevor"
        ],
        "spouse": null
    };
    const columns = [
        {
            title: 'S.No.',
            dataIndex: 'sno',
            key: 'sno',
            className: 'table_first_col',
            render: (value, item, index) => (page - 1) * 10 + index + 1
        },
        {
            title: 'Log Id',
            dataIndex: 'ReferenceId',
            key: 'ReferenceId',
            className: 'table_status_col',
            render: (value, item, index) => {
                return (
                    <span>{"54484ddf5weed85"}</span>
                )
            }
        },
        {
            title: 'Log Type',
            dataIndex: 'ReferenceId',
            key: 'ReferenceId',
            className: 'table_status_col',
            render: (value, item, index) => {
                return (
                    <span>{"Callback"}</span>
                )
            }
        },
        {
            title: 'Request Id',
            dataIndex: 'Category',
            key: 'Category',
            className: 'text-capitalize',
            render: (value, item, index) => {
                return (
                    <span>{"edrt795989yrtdc889"}</span>
                )
            }
        },

        {
            title: 'Requester (HIU/HIP)',
            dataIndex: 'Category',
            key: 'Category',
            className: 'text-capitalize',
            render: (value, item, index) => {
                return (
                    <span>{"demo_hip"}</span>
                )
            }
        },


        {
            title: 'Patient Name/Patient Id',
            dataIndex: 'ReferenceId',
            key: 'ReferenceId',
            className: 'table_status_col patient',
            render: (value, item, index) => {
                return (
                    <span>{"Amit/PID001"}</span>
                )
            }
        },
        {
            title: 'PHR Address',
            dataIndex: 'ReferenceId',
            key: 'ReferenceId',
            className: 'table_status_col',
            render: (value, item, index) => {
                return (
                    <span>{"amit9119@abdm"}</span>
                )
            }
        },

        {
            title: 'URL',
            dataIndex: 'Status',
            key: 'Status',
            className: 'table_status_col',
            render: (value, item, index) => {
                return (
                    <a href='#'>https://www.lalpathlabs.com/abha</a>
                )
            }
        },
        {
            title: 'Date Time',
            dataIndex: 'Title',
            key: 'Title',
            className: 'abha-link-date',
            render: (value, item, index) => {
                return (
                    <span>{"29-03-2023 11:53:24"}</span>
                )
            }
        },
        {
            title: 'Requested Data',
            dataIndex: 'Status',
            key: 'Status',
            className: 'table_status_col',
            render: (value, item, index) => {
                return (
                    <Button className="view-btn" type="primary" onClick={() => setModal1Open(true)} > View</Button>
                )
            }
        },
        {
            title: 'Response Data',
            dataIndex: 'Status',
            key: 'Status',
            className: 'table_status_col',
            render: (value, item, index) => {
                return (
                    <Button className="view-btn" type="primary" onClick={() => setModal1Open(true)} > View</Button>
                )
            }
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'actiion',
    className: 'abha-link-action',
            with: 400,
            render: (value, item, index) => {
                return (
                    <> <Tooltip placement="top" title={"Link & Notify"}>
                        <a style={{ textDecoration: "underline" }} href={"#"}><LinkOutlined /></a>
                        </Tooltip>
                        <Tooltip placement="top" title={"Upload Report"}>
                        <Upload {...props}>
                            <Button className='view-btn' ><UploadOutlined /></Button>
                        </Upload>
                        </Tooltip>
                    </>
                )
            }
        },
    ];
    return (
        <div>
            <Row gutter={[10, 10]} align={"middle"}>
                <Col lg={3} md={24} sm={24} xs={24}>
                    <HeadingBack title={"Report Requested"} subHeading={`Records ${20 || 0}`} />
                </Col>
                <Col lg={19} md={12} sm={24} xs={24}>
                    <AbhaLinkedFilter filter={filter} setFilter={setFilter} setPage={setPage} />
                </Col>
                {/* <Col lg={2} md={24} sm={24} xs={24}>
                    <div className='flex justify-content-end align-items-center'>
                        <Tooltip title="Add"><span className='jop_btn' onClick={() => navigate("/faq/add")}>Add<SvgIcon.Add width={40} height={40} className="cursor-pointer" /></span></Tooltip>
                    </div>
                </Col> */}
            </Row>
            <div className='tableResponsive mt-10'>
                <Table
                    rowKey='Id'
                    className={isLoading ? 'table antd_table no_data_found_hide' : 'table antd_table'}
                    bordered
                    columns={columns}
                    dataSource={Array.isArray(columns) && columns?.length > 0 ? columns : []}
                    pagination={{
                        current: page,
                        pageSize: 10,
                        onChange(current, pageSize) {
                            setPage(current);
                        },
                        hideOnSinglePage: true,
                        /* total: totalFaq,
                        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                        responsive: true */
                    }}

                />
                <Modal
                    style={{
                        top: 20,
                    }}
                    open={modal1Open}
                    onOk={() => setModal1Open(false)}
                    onCancel={() => setModal1Open(false)}
                    footer={null}
                >
                    <pre>{JSON.stringify(json, null, 2)}</pre>

                </Modal>
            </div>
        </div>
    )
}

export default ReportRequested